"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmpty = isEmpty;
exports.errOrData = errOrData;
exports.mergeEithers = mergeEithers;
const purify_ts_1 = require("purify-ts");
const non_empty_list_1 = require("@codegrade/non-empty-list");
function isEmpty(val) {
    return (val ?? '').match(/\S/) == null;
}
function errOrData(errs, data) {
    return non_empty_list_1.NonEmptyList.fromArray(errs).toEither(data).swap();
}
function mergeEithers(a, b) {
    return a.caseOf({
        Left: errA => b.caseOf({
            Left: errB => (0, purify_ts_1.Left)(errA.concat(errB)),
            Right: () => (0, purify_ts_1.Left)(errA),
        }),
        Right: dataA => b.caseOf({
            Left: errB => (0, purify_ts_1.Left)(errB),
            Right: dataB => (0, purify_ts_1.Right)({ ...dataA, ...dataB }),
        }),
    });
}
